import { useAuthUser } from "react-auth-kit";
import { getRegistryURL } from "./Registry";
import { buildGetOptions, buildPostOptions, fetchWithErrorHandling } from "../FetchUtils";

export interface ITfidTags {
  tags: string[];
  label?: string;
  env?: string;
  ts?: number;
}

export interface IAllTfidTagsResponse {
  content: Record<string, ITfidTags>;
}

const endpoint = (action: string): string => {
  return `${getRegistryURL()}/v1/registry/tfid-tags/${action}`;
};

export const upsertTfidTag = async (
  accessToken: string,
  id: string,
  tags: string[],
  label?: string,
  env?: string,
  ts?: number,
) => {
  const body: { id: string; tags: string[]; label?: string; env?: string; ts?: number } = { id, tags };
  if (label !== undefined) {
    body.label = label;
  }
  if (env !== undefined) {
    body.env = env;
  }
  if (ts !== undefined) {
    body.ts = ts;
  }
  return fetchWithErrorHandling(endpoint("upsert"), buildPostOptions(accessToken, body));
};

export const getAllTfidTags = async (accessToken: string) => {
  return fetchWithErrorHandling(endpoint("all"), buildGetOptions(accessToken));
};

export const useTfidTagsService = () => {
  const authUser = useAuthUser();
  const accessToken = authUser()?.access_token;

  return {
    upsertTfidTag: (id: string, tags: string[], label?: string, env?: string, ts?: number) =>
      upsertTfidTag(accessToken, id, tags, label, env, ts),
    getAllTfidTags: () => getAllTfidTags(accessToken),
  };
};
